var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2027 1.52597C16.2027 1.83789 16.2332 2.14279 16.289 2.43907C16.5481 3.81109 17.378 4.98854 18.5285 5.72437L18.5301 5.72621C19.3309 6.23782 20.2857 6.53628 21.31 6.53628V10.1377C19.4063 10.1377 17.6426 9.54073 16.2027 8.52642V15.8446C16.2027 19.5002 13.1718 22.474 9.44605 22.474C8.00618 22.474 6.67177 22.0285 5.57408 21.2722C3.83196 20.072 2.68945 18.0882 2.68945 15.8454C2.68945 12.1898 5.72038 9.21598 9.44605 9.21598C9.75551 9.21598 10.0585 9.24108 10.3567 9.28109V12.957C10.0681 12.8692 9.76345 12.8174 9.44605 12.8174C7.74471 12.8174 6.35998 14.1761 6.35998 15.8454C6.35998 17.008 7.03155 18.0176 8.01417 18.5251L8.01473 18.5263C8.44231 18.7465 8.92982 18.8742 9.44605 18.8742C11.1082 18.8742 12.4642 17.5775 12.5257 15.9607L12.5313 1.52597H16.2027Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLine);
export default __webpack_public_path__ + "static/media/tiktok_line.88ac3ab87c5a382a0178957ac8f63fc3.svg";
export { ForwardRef as ReactComponent };